import 'consumerweb-shim';
import 'adsinterceptor';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import { get } from 'lodash';
import { Row, Col, Text } from 'pp-react';
import MediaQuery from 'react-responsive';
import getContent, { init } from 'react-i18n';
import { Footer } from 'marketing-components';

import store from '../components/redux/store/configStore';
import Carousel from '../components/redux/containers/carouselContainer';
import Charity from '../components/redux/containers/campaignCharityDesktopContainer';
import Promotion from '../components/promotion';
import About from '../components/about';
import LiveStream from '../components/redux/containers/liveStreamContainer';
import SimpleHeader from '../components/SimpleHeader';
import SearchBox from '../components/redux/containers/searchboxConatiner';
import Confirmation from '../components/confirmationPage';
import SocialShare from '../components/SocialShare';
import CharityMobile from '../components/redux/containers/campaignCharityMobileContainer';
import CheckoutError from '../components/checkoutError';
import DonationSteps from '../components/donation-steps';
import Disclosure from '../components/disclosure';
import CobrandedHeader from '../components/cobranded-header';
import Stripe from '../components/stripe';

import { isPPGF } from '../lib/charity';

init({ contentNode: document.getElementById('data-messages') });
const i18n = getContent('fundraiser/container/charityContainer');

class Main extends React.Component {
  constructor(props, context) {
    super(props, context);
    var nameValues = this.parseFPTIInfo(props && props.fptiInfo);
    var initialState = {
      fptiInfo: {
        pgrp: nameValues.pgrp,
        page: nameValues.page,
      },
      isMobile: false,
    };
    this.state = initialState;
  }

  componentDidMount() {
    let isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        isMobile,
      });
    }
  }

  parseFPTIInfo = fptiData => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  renderHeader = () => {
    const cobranded = get(
      this.props.templateData,
      'campaignBranding.campaignBrand',
      ''
    );
    const logo = get(this.props.templateData, 'lpContents.logoImage');
    if (cobranded.toUpperCase() === 'COBRANDED' && logo) {
      return <CobrandedHeader cobrandedLogo={logo} />;
    } else {
      return <SimpleHeader allCharityCampaign={true} />;
    }
  };

  renderCarousel = () => {
    return <Carousel fptiInfo={this.state.fptiInfo} />;
  };

  renderSearchBox = () => {
    const enabled =
      get(this.props.templateData, 'lpContents.searchRequired', 'yes') ===
      'yes';
    const required =
      get(
        this.props.templateData,
        'lpContents.donationTermsRequired',
        'yes'
      ) === 'yes';
    const searchBoxStyle = required
      ? 'searchBoxDiv'
      : 'searchBoxDivWithNoStrip';

    if (enabled) {
      return (
        <div className={searchBoxStyle}>
          <SearchBox isMobile={this.props.deviceType === 'MOBILE'} />
        </div>
      );
    }
  };

  renderDisclosure = () => {
    const disclosureType = this.props.data.partner;
    const deviceType = this.props.deviceType;

    const cobranded = get(
      this.props.templateData,
      'campaignBranding.campaignBrand',
      ''
    );
    const logo =
      cobranded.toUpperCase() === 'COBRANDED'
        ? get(this.props.templateData, 'lpContents.logoImage')
        : undefined;

    return (
      <Disclosure
        type={disclosureType}
        device={deviceType}
        cobrandedLogo={logo}
      />
    );
  };

  renderPopupModal = () => {
    const donation = get(this.props, 'donationInfo.donated');
    if (donation) {
      if (donation === 1) {
        return (
          <Confirmation
            fptiInfo={this.state.fptiInfo}
            campaignInfo={this.props.data}
            confirmationDetails={this.props.templateData.confirmation}
            pageurl={this.props.data.eventUrl}
          />
        );
      } else if (donation === 0) {
        return <CheckoutError fptiInfo={this.state.fptiInfo} />;
      }
    }
  };

  renderDonationSteps = () => {
    let enabled =
      get(
        this.props.templateData,
        'lpContents.donationStepsRequired',
        'yes'
      ) === 'yes';
    if (enabled) {
      return <DonationSteps />;
    }
  };

  renderTermsAndConditions = () => {
    let legalFooterTermsRequired =
      get(this.props.templateData, 'lpContents.footerLegalText', 'yes') ===
      'yes';

    let legalFooterContent =
      get(
        this.props.templateData,
        'lpContents.legalFooterContent', i18n('label.gifts-that-do-more')
      );

    if (legalFooterTermsRequired) {
      return (
        <div id={'terms-conditions'} className={'container policyInfo'}>
          <Text
            dangerouslySetInnerHTML={{
              __html: legalFooterContent,
            }}
            as='p'
            size='sm'
          />
        </div>
      );
    }
  };

  renderStripe = () => {
    const required = get(
      this.props,
      'templateData.lpContents.donationTermsRequired',
      'yes'
    );
    if (required.toLowerCase() === 'yes') {
      const message = get(
        this.props,
        'templateData.lpContents.donationTermsTextInput'
      );
      const stripe = (
        <Stripe fptiInfo={this.props.fptiInfo} message={message} isPPGF={(isPPGF(this.props.charities[0].charity_type))} />
      );
      return stripe;
    }
  };

  renderCharity = () => {
    if (this.props.deviceType === 'MOBILE') {
      return <CharityMobile fptiInfo={this.state.fptiInfo} />;
    } else {
      return <Charity fptiInfo={this.state.fptiInfo} />;
    }
  };

  renderLiveStream = () => {
    const enabled =
      get(this.props.templateData, 'lpContents.liveFeedNeeded', 'yes') ===
      'yes';
    if (enabled) {
      return <LiveStream fptiInfo={this.state.fptiInfo} />;
    }
  };

  renderColumns = () => {
    const templateData = this.props.templateData;
    const promotionModuleEnabled =
      get(templateData, 'promotionModuleNeeded', 'yes') === 'yes';
    const liveFeedEnabled =
      get(templateData, 'lpContents.liveFeedNeeded', 'yes') ===
      'yes';
    const aboutModuleEnabled =
      get(templateData, 'aboutModuleNeeded', 'yes') === 'yes';

    let promotionModule = (
      <Promotion
        promoModule={templateData.promotionModule}
        fptiInfo={this.state.fptiInfo}
      />
    );
    let aboutModule = (
      aboutModuleEnabled &&
      <About
        title={templateData.aboutModule.header}
        content={templateData.aboutModule.content}
        aboutStyle={'regular'}
      />
    );

    let aboutModuleHigh = (
      aboutModuleEnabled &&
      <About
        title={templateData.aboutModule.header}
        content={templateData.aboutModule.content}
        aboutStyle={'high'}
      />
    );

    let aboutModuleMobile = (
      aboutModuleEnabled &&
      <About
        title={templateData.aboutModule.header}
        content={templateData.aboutModule.content}
        aboutStyle={'mobile'}
      />
    );
    let liveStreamModule = <LiveStream fptiInfo={this.state.fptiInfo} />;
    if (promotionModuleEnabled && liveFeedEnabled) {
      return (
        <div className={'mainIndexPanel'}>
          <MediaQuery minWidth={769}>
            <Row>
              <Col xs={6} md={6} lg={6}>
                {promotionModule}
                {aboutModule}
              </Col>
              <Col xs={6} md={6} lg={6}>
                {liveStreamModule}
              </Col>
            </Row>
          </MediaQuery>
          <MediaQuery maxWidth={768}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {promotionModule}
                {aboutModuleMobile}
                {liveStreamModule}
              </Col>
            </Row>
          </MediaQuery>
        </div>
      );
    } else if (promotionModuleEnabled) {
      return (
        <div className={'mainIndexPanel'}>
          <MediaQuery minWidth={769}>
            <Row>
              <Col xs={6} md={6} lg={6}>
                {promotionModule}
              </Col>
              <Col xs={6} md={6} lg={6}>
                {aboutModule}
              </Col>
            </Row>
          </MediaQuery>
          <MediaQuery maxWidth={768}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {promotionModule}
                {aboutModuleMobile}
              </Col>
            </Row>
          </MediaQuery>
        </div>
      );
    } else if (liveFeedEnabled) {
      return (
        <div className={'mainIndexPanel'}>
          <MediaQuery minWidth={769}>
            <Row>
              <Col xs={6} md={6} lg={6}>
                {aboutModuleHigh}
              </Col>
              <Col xs={6} md={6} lg={6}>
                {liveStreamModule}
              </Col>
            </Row>
          </MediaQuery>
          <MediaQuery maxWidth={768}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {aboutModuleMobile}
                {liveStreamModule}
              </Col>
            </Row>
          </MediaQuery>
        </div>
      );
    } else {
      aboutModule = (
        aboutModuleEnabled &&
        <About
          title={templateData.aboutModule.header}
          content={templateData.aboutModule.content}
          aboutStyle={'regular'}
          textCenter={true}
        />
      );
      return (
        <div className={'mainIndexPanel'}>
          <MediaQuery minWidth={769}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {aboutModule}
              </Col>
            </Row>
          </MediaQuery>
          <MediaQuery maxWidth={768}>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {aboutModuleMobile}
              </Col>
            </Row>
          </MediaQuery>
        </div>
      );
    }
  };

  renderSocialShare = () => {
    let enabled =
      get(this.props.templateData, 'socialShareNeeded', 'yes') === 'yes';
    if (enabled) {
      return (
        <div>
          <Text size='md' as='p' className={'socialShareHeader'}>
            {i18n('title.socialShareHeader')}
          </Text>
          <SocialShare
            url={window.location.href}
            campaignInfo={this.props.data}
            fptiInfo={this.state.fptiInfo}
          />
        </div>
      );
    }
  };

  renderFooter = () => {
    if (this.props.data.mppFooter) {
      const {
        content: { content: footerContent },
      } = JSON.parse(document.getElementById('data-footer').innerHTML);
      const { localeCountry } = footerContent;

      return (
        <Footer
          content={footerContent}
          localeCountry={localeCountry}
          flagHref={`https://www.paypal.com/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
        />
      );
    }
  };

  render() {
    return (
      <div>
        {this.renderHeader()}
        {this.renderCarousel()}
        {this.renderSearchBox()}
        {this.renderStripe()}
        {this.renderCharity()}
        {this.renderPopupModal()}
        {this.renderDisclosure()}
        {this.renderColumns()}
        {this.renderDonationSteps()}
        {this.renderSocialShare()}
        {this.renderTermsAndConditions()}
        {this.renderFooter()}
      </div>
    );
  }
}

const AllFundraiser = connect(state => ({
  npid: state,
  charity: state.charity,
  donationInfo: state.server.donationInfo,
  charities: state.server.data.charities,
  deviceType: state.server.deviceType,
  data: state.server.data,
  templateData: state.server.templateData,
  fptiInfo: state.server.fptiInfo,
}))(Main);

ReactDOM.render(
  <Provider store={store}>
    <AllFundraiser />
  </Provider>,
  document.getElementById('fundraiser')
);
